import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useNavigate } from 'react-router-dom';

const pinIcon = L.divIcon({
  className: '',
  html: `<div style="position:relative;width:26px;height:34px;">
    <svg viewBox="0 0 24 32" width="26" height="34" style="filter:drop-shadow(0 2px 4px rgba(0,0,0,.6))">
      <path d="M12 0C5.4 0 0 5.4 0 12c0 8.6 12 20 12 20s12-11.4 12-20C24 5.4 18.6 0 12 0z" fill="#F6B24A"/>
      <circle cx="12" cy="12" r="5" fill="#1A1208"/>
    </svg></div>`,
  iconSize: [26, 34],
  iconAnchor: [13, 34],
  popupAnchor: [0, -30],
});

function FitBounds({ markers }) {
  const map = useMap();
  const done = useRef(false);
  useEffect(() => {
    if (done.current || !markers.length) return;
    done.current = true;
    if (markers.length === 1) {
      map.setView([markers[0].lat, markers[0].lon], 15);
    } else {
      map.fitBounds(markers.map((m) => [m.lat, m.lon]), { padding: [30, 30], maxZoom: 15 });
    }
  }, [map, markers]);
  return null;
}

export function VenueMap({ markers = [], height = 220, linkToVenue = true, className = '' }) {
  const nav = useNavigate();
  const valid = markers.filter((m) => typeof m.lat === 'number' && typeof m.lon === 'number' && (m.lat !== 0 || m.lon !== 0));
  if (!valid.length) return null;
  const center = [valid[0].lat, valid[0].lon];

  return (
    <div
      className={`overflow-hidden rounded-2xl border border-white/10 ${className}`}
      style={{ height }}
      data-testid="venue-map"
    >
      <MapContainer center={center} zoom={13} style={{ height: '100%', width: '100%', background: '#0B0C10' }} scrollWheelZoom={false} attributionControl={false}>
        <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
        <FitBounds markers={valid} />
        {valid.map((m) => (
          <Marker key={m.id || `${m.lat}-${m.lon}`} position={[m.lat, m.lon]} icon={pinIcon}>
            <Popup>
              <div style={{ minWidth: 140 }}>
                <p style={{ margin: 0, fontWeight: 700, fontSize: 13 }}>{m.name}</p>
                {m.subtitle && <p style={{ margin: '2px 0 0', fontSize: 11, color: '#666' }}>{m.subtitle}</p>}
                {linkToVenue && m.id && (
                  <button
                    type="button"
                    onClick={() => nav(`/venue/${m.id}`)}
                    style={{ marginTop: 6, background: '#F6B24A', color: '#1A1208', border: 'none', borderRadius: 8, padding: '4px 10px', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}
                    data-testid={`map-popup-open-${m.id}`}
                  >
                    View venue
                  </button>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
